const searchMap = {
  // 用户历史搜索记录 get
  getSearchHistory: '/usb/uwb-app/api/v1/searchHistory/list',

  // 热搜关键词
  getHotWords: '/usb/uwb-app/api/v1/home/hotWords',

  // 转链 /home/chainTransfer
  chainTransfer: '/usb/uwb-app/api/v1/home/chainTransfer',

  // 添加历史搜索记录
  addSearchHistory: '/usb/uwb-app/api/v1/searchHistory/save',

  // 删除用户历史搜索记录
  delSearchHistory: '/usb/uwb-app/api/v1/searchHistory/delete',

  // 关键词搜索
  searchKey: '/usb/uwb-app/api/v1/search/keywordSearch',
};
export default searchMap;
